<template>

	<!-- Header -->
	<header class="header">
		
		<div class="row header__row">
			<div class="columns small-6 medium-5 large-5">
				<!-- Logo -->
				<div class="logo header__logo">
					<router-link to="/" class="logo__link">
						<img class="logo__img" src="../../assets/img/logo-text.png" alt="logo">
					</router-link>
				</div>
				<!-- Logo End -->

				<!-- Select -->
				<div class="header__select hide-for-small">
					<select2 class="select"
									 placeholder="Введите название города" v-model="city"
									 :httpOptions="httpConfig" :label="'name'" :id="'_id'"
									 @change="selectCity">
						<option :value="currentCity._id" slot="defaultValue" v-if="currentCity._id">{{currentCity.name}}</option>
					</select2>
				</div>
				<!-- Select End -->
			</div>

			<div class="columns small-6">
				<!-- Mobile Menu Nav -->
				<div class="mobile-menu mobile-menu_right">
					<img src="./../../assets/img/agenda.svg" class="agenda-btn" @click="toggleRegistry" v-if="isRegistry">
					<div class="mobile-menu__btn trans clear_fix" @click="toggleMenu($event)">
						<i class="fa fa-bars mobile-menu__icon mobile-menu__icon_open" aria-hidden="true"></i>
					</div>
				</div>
				<!-- Mobile Menu Nav End -->
			</div>

			<div class="columns small-12 medium-5 large-4 hide-768">
				<!-- Site phone -->
				<div class="site-phone header__site-phone">
					<p class="site-phone__item site-phone__item">
					<router-link :to="{name: 'Offer'}" class="offer" target="_blank">Врачам | Клиникам</router-link> +380 66 934 32 89</p>
				</div>
				<!-- Site phone End -->
			</div>

			<div class="columns small-12 medium-2 large-3 hide-768 pos_r">
				<account-switcher :rooms="rooms" :account="activeAccount" :overlay="true"></account-switcher>
			</div>
		</div>

		<!-- Row End -->
		<div class="row header__row hide-768" v-if="(!isDoctor || !inCabinet)">
			<div class="columns small-12 medium-12 large-12 ">

				<!-- Main menu -->
				<nav class="main-menu header__main-menu">
					<ul class="main-menu__list clear_fix">

						<li class="main-menu___item">
							<router-link activeClass="main-menu__active" :to="{name: 'Doctors'}" class="main-menu__link">
								Врачи
							</router-link>
						</li>

						<li class="main-menu___item">
							<router-link activeClass="main-menu__active" :to="{name: 'Clinics'}" class="main-menu__link">
								Клиники
							</router-link>
						</li>

						<li class="main-menu___item">
							<router-link activeClass="main-menu__active" class="main-menu__link"
													 :to="{name: 'Cabinet', params: {id: activeAccount._id || '45'}}">
								Кабинет
							</router-link>
						</li>

					</ul>
				</nav>
				<!-- Main menu End -->

			</div>
		</div>
		<!-- Row End -->

		<mobile-header :rooms="rooms" :account="activeAccount"
									 :currentCity="currentCity" @selectCity="selectCity"></mobile-header>

	</header>
	<!-- Header End -->

</template>

<script>
	import Role from '@/common/Role';
	import AccountSwitcher from '@/components/header/AccountSwitcher.vue';
	import MobileHeader from '@/components/header/mobileHeader.vue'

	export default {
		name: 'Header',
		components: {AccountSwitcher, MobileHeader},
		computed: {
			logged() {
				return this.$store.state.auth.logged
			},
			isDoctor() {
				return this.$store.state.auth.isDoctor
			},
			user() {
				return this.$store.state.auth.user
			},
			worker() {
				return this.$store.state.auth.worker
			},
			clinic() {
				return this.$store.state.auth.clinic
			},
			Role() {
				return new Role(this.$store.state.auth.user, this.$store.state.auth.worker, this.$store.state.auth.clinic)
			},
			activeAccount() {
				if(this.$store.state.auth.isDoctor) {
					return this.worker
				}

				return this.user
			},
			rooms() {
				if(this.activeAccount._id) {
					return [this.user].concat(this.$store.state.auth.user.workers)
						.filter(room => room._id !== this.activeAccount._id)
				}
			},
			isRegistry() {
				return /\/cabinet\/[a-z0-9]+\/registry\/[a-z0-9]+/.test(this.$route.fullPath)
			},
			inCabinet() {
				return /\/cabinet\/[a-z0-9]+/.test(this.$route.fullPath)
			}
		},
		mounted() {

			//TODO need to refactor
			if(!this.$storage.isExist('X-Local-City')) {
				this.$storage.set('X-Local-City', '5983ab39c7fa86462f625ecf');
			}

			//TODO and this need refactor too
			this.$store.dispatch('city/get', this.$storage.get('X-Local-City')).then(city => {
				this.currentCity = city;
				return city;
			}).then(city => {
				this.city = city._id;
			});
		},
		data() {
			return {
				city: '',
				currentCity: {},
				httpConfig: {
					url: process.env.API_LINK + '/city/all/get',
					method: 'GET',
					data: {
						term: this.city
					}
				}
			}
		},
		methods: {
			toggleMenu() {
				$('.mobile-menu-list')
					.stop(true, true)
					.slideToggle();
			},
			selectCity(id) {
				if(id !== this.$storage.get('X-Local-City')) {
					this.$storage.set('X-Local-City', id || this.city);
					location.reload();
				}

				this.$storage.set('X-Local-City', id || this.city);
			},
			toggleRegistry() {
				this.$event.send('toggleRegistryMenu', {})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.fix {
		line-height: 96px;
		text-align: center;
		font-size: 3em;
		color: #333;
	}

	.logged-user__icon {
		transition: all 0.2s ease;
	}

	.revert {
		transform: rotate(180deg);
	}

	.header__logged-user.list__item {
		padding-left: 40px;
		justify-content: flex-start;
	}

	.main-menu__active {
		background-color: #06A6C9;
		color: #fff;
		padding: 10px;
	}
</style>



// WEBPACK FOOTER //
// index.vue?b8ef6e7c